import HeaderSection from '../../../../../components/Header/HeaderSection';
import CardTransparent from '../../../../../components/CockpitCards/CardTransparent';


export default function MouthCompositionText() {

    
    return (

     <CardTransparent content = {
        <HeaderSection

            headline_p1 = "How Your " 
            headline_grey = "Mouth Microbiome Composition"
            headline_p2 = "Affects Your Health"

            text1 = "The oral microbiome is a vast community of microorganisms that live in cheeks, tongue, teeth and other parts in the mouth. These microorganisms play a crucial role in oral health with broader implications for overall body health."
            text2 = "In this section, we provide an overview of your personal oral microbiome based on a comprehensive analysis. Using advanced metagenomic sequencing, we looked closely at the full range of microbes in your mouth."
            text3 = "To make interpretation easy, we've focused on the most relevant findings. You'll find helpful explanations in the Important Read tab."

            />
    }/>
            
  )
}